const FormResources = {

    form_data:  {
        name:                '',
        cost_center:         '',
        director_first_name: '',
        director_last_name:  '',
        director_ext:        '',
        notes:               '',
    },
    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Cost Center:',
            model_name: 'cost_center',
            ref:        'cost_center_input',
            ref_alt:    'cost_center_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       `Director's First Name:`,
            model_name: 'director_first_name',
            ref:        'director_first_name_input',
            ref_alt:    'director_first_name_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       `Director's last name:`,
            model_name: 'director_last_name',
            ref:        'director_last_name_input',
            ref_alt:    'director_last_name_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  15,
            disabled:   false,
            step:       '',
            name:       `Director's Ext:`,
            model_name: 'director_ext',
            ref:        'director_ext_input',
            ref_alt:    'director_ext_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Notes:',
            model_name: 'notes',
            ref:        'notes_input',
            ref_alt:    'notes_input_alt',
            required:   false,
        },

    ]

}

export default FormResources